import { render, staticRenderFns } from "./CmgExitMobileVerificationModal.vue?vue&type=template&id=efa10b22&scoped=true&lang=pug&"
import script from "./cmg-exit-mobile-verification-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-exit-mobile-verification-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgExitMobileVerificationModal.vue?vue&type=style&index=0&id=efa10b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa10b22",
  null
  
)

export default component.exports